import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { auth } from "../firebase";

/**
 * Logout route. Signs the user out of the platform Firebase session and then
 * either redirects to `?return=<url>` (used by TVM via Browser plugin to
 * complete a global SSO logout) or back to /login.
 */
export function LogoutRoute() {
  const [searchParams] = useSearchParams();
  const returnUrl = searchParams.get("return");
  const { t } = useTranslation();

  useEffect(() => {
    auth.signOut()
      .catch((e) => console.error("[logout] signOut failed", e))
      .finally(() => {
        window.location.href = returnUrl ?? "/login";
      });
  }, [returnUrl]);

  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "4rem 1rem",
      textAlign: "center",
    }}>
      <p>{t("logout.signingOut")}</p>
    </div>
  );
}
